import type { BenefitWorkflowResponse } from "./benefit-types"
import { relationshipLabels } from "./benefit-enums"

export function canCorrectApplicantHousehold(workflow: BenefitWorkflowResponse | null): boolean {
  return workflow?.authority === "V2" && workflow.applicantHouseholdCorrection?.enabled === true
}

export function correctionValidation(
  memberIds: string[], applicant: string, relationships: Record<string, string>,
  confirmed: boolean, reviewed: boolean,
): string | null {
  if (!memberIds.includes(applicant) || new Set(memberIds).size !== memberIds.length)
    return "Choose one applicant from the resulting household, with no duplicate people."
  if (memberIds.some(id => !Object.hasOwn(relationshipLabels, relationships[id] ?? "") ||
    relationships[id] === "255" || (relationships[id] === "0") !== (id === applicant)))
    return "Confirm a relationship for every member relative to the new applicant."
  if (!confirmed || !reviewed) return "Confirm the relationships and review the affected application facts."
  return null
}
